import { render, staticRenderFns } from "./PurchaseSum2.vue?vue&type=template&id=23819feb&scoped=true"
import script from "./PurchaseSum2.vue?vue&type=script&lang=js"
export * from "./PurchaseSum2.vue?vue&type=script&lang=js"
import style0 from "./PurchaseSum2.vue?vue&type=style&index=0&id=23819feb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23819feb",
  null
  
)

export default component.exports